export const actionPrefix = "@wevo/aurora";



// WEBPACK FOOTER //
// ./src/modules/constants.js